import React from 'react';
import styled from 'styled-components';
import { imageUtil } from '../../../utils';
import BookCover from './index';

export const getCoverImage = (book) =>
  book?.cover?.highRes?.url ??
  'https://storage.googleapis.com/beta-reader-prod.appspot.com/defaults/DEFAULT_COVER_BACKGROUND.png';

const CoverContainer = styled.div`
  position: relative;
  min-height: 200px;
  margin-top: -1em;
  ${'' /* margin-bottom: 1em; */}
  height: 200px;
  justify-content: center;
  align-items: center;
  display: flex;
  overflow: hidden;

  /* Blurred background layer */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('${({ $background }) => $background}');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    filter: blur(10px);
    z-index: 0;
  }

  /* Ensure children are above blurred background */
  > * {
    position: relative;
    z-index: 1;
  }
`;

const SharpImageContainer = styled.div`
  height: 200px;
  box-shadow: inset 0 -3em 3em rgba(0, 0, 0, 0.1), 0 0 0 2px rgb(255, 255, 255);
`;

const SharpImage = styled.img`
  height: 200px;
  width: auto;
  object-fit: contain;
  box-shadow: inset 0 -3em 3em rgba(0, 0, 0, 0.1), 0 0 0 2px rgb(255, 255, 255);
`;

const CoverWrapper = ({ book, editable }) => {
  const coverImage = getCoverImage(book);
  return (
    <CoverContainer
      data-default-cover={coverImage.includes('/defaults/DEFAULT_COVER_BACKGROUND.png') ? 'true' : undefined}
      $background={imageUtil.getImageUrl({
        operation: 'width',
        size: 150,
        filter: 'f=blur:10',
        originalImageUrl: coverImage,
      })}
    >
      {!editable && (
        <SharpImage
          alt={book?.title ? `Cover of ${book.title}` : 'Book cover'}
          src={imageUtil.getImageUrl({
            operation: 'width',
            size: 150,
            originalImageUrl: coverImage,
          })}
        />
      )}
      {editable && (
        <SharpImageContainer className='editable'>
          <BookCover style={{ height: '200px!important' }} />
        </SharpImageContainer>
      )}
    </CoverContainer>
  );
};

export default CoverWrapper;
